import { useContext, useEffect, useState } from "react";
import { AppContext } from '../../utils/ContextProvider';
import Swal from 'sweetalert2';
import GlobalSVG from "../../utils/GlobalSVG";
import API from '../../utils/API';
import LoaderWheel from "../LoaderWheel";

const LiquidConsumptionLine = (props) => {
    const context = useContext(AppContext);
    const [data, setData] = useState(null);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        if (!props.data) return;
        setData(props.data);
    }, [props]);

    const handleDelete = (id) => {
        setDeleting(true);
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will mark the liquid consumption as deleted!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                const cancelToken = API.cancelToken();
                const payload = {liquid_consumption: [{ ...data, deleted: 1 }] }
                API.putChannel(cancelToken, props.selectedChannel.id, payload)
                    .then(res => {
                        // Update parent to exclude deleted items in UI
                        props.setSelectedChannel({
                            ...props.selectedChannel,
                            liquid_consumption: payload.liquid_consumption.filter(l => l.id === data.id)
                        });
                    })
                    .catch(e => {
                        console.error(e);
                        Swal.fire({
                            title: 'Oops!',
                            text: 'An error occurred, please try again later.',
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    })
                    .finally(() => {
                        setDeleting(false);
                    });
            } else {
                setDeleting(false);
            }
        });
    };

    const updateLiquid = (event) => {
        let { name, value } = event.target;
        switch (name){
            case "name": default:
                break
            case "stage":
                value = parseInt(value)
                break
            case "amount":
                value = parseFloat(value)
                break
        }
        const updatedLiquid = {
            ...data,
            [name]: value
        };
        let updatedLiquidConsumptions;

        if (data.id) {
            // Update existing item with matching id
            updatedLiquidConsumptions = props.selectedChannel.liquid_consumption.map(l =>
                l.id === data.id ? updatedLiquid : l
            );
        } else {
            updatedLiquidConsumptions = props.selectedChannel.liquid_consumption
            // Add new item (no id) to the end of the list
            let newItemFiltered = props.selectedChannel.liquid_consumption.filter(l => l.inId === data.inId)
            if (!newItemFiltered.length) {
                updatedLiquid.inId = Math.floor(Math.random() * 1000000) + 1
                updatedLiquidConsumptions.push(updatedLiquid)
            }
            updatedLiquidConsumptions = props.selectedChannel.liquid_consumption.map(l => l.inId === data.inId ? updatedLiquid : l)

        }

        props.setSelectedChannel({
            ...props.selectedChannel,
            liquid_consumption: updatedLiquidConsumptions
        });
        setData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div>
            {data && (
                <div className='flex flex-nowrap justify-between items-center p-4 my-2 w-full bg-[#ededed] rounded-md relative'>
                    <div className="flex flex-col gap-3">
                        <label htmlFor="stage" className="text-[12px] font-semibold ">Stage</label>
                        <input
                            type="number"
                            onChange={updateLiquid}
                            name="stage"
                            disabled={!props.adding && !props.edit}
                            className="text-[12px] font-semibold w-[100px] outline-none hide-input-background"
                            value={data.stage || ''}
                            placeholder="Stage"
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <label htmlFor="amount" className="text-[12px] font-semibold ">Amount</label>
                        <input
                            type="number"
                            onChange={updateLiquid}
                            name="amount"
                            disabled={!props.adding && !props.edit}
                            className="text-[12px] font-semibold w-[100px] outline-none hide-input-background"
                            value={data.amount || ''}
                            placeholder="Amount"
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <label htmlFor="amounament" className="text-[12px] font-semibold ">Name</label>
                        <input
                            type="text"
                            onChange={updateLiquid}
                            name="name"
                            disabled={!props.adding && !props.edit}
                            className="text-[12px] font-semibold w-[150px] outline-none hide-input-background"
                            value={data.name || ''}
                            placeholder="Name"
                        />
                    </div>
                    <div className="flex flex-nowrap justify-end items-center">
                        {props.edit && context.getUserInfo && context.getUserInfo.manage_maintenance_settings && (
                            <div className='cursor-pointer w-[25px]'>
                                {deleting ? (
                                    <LoaderWheel />
                                ) : (
                                    <div
                                        className='cursor-pointer w-[15px] h-[18px]'
                                        onClick={() => handleDelete(data.id)}
                                    >
                                        {GlobalSVG.delete()}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LiquidConsumptionLine;